import api from './api';

export const adminService = {
    // Levels
    createLevel: async (data) => await api.post('/admin/levels', data),
    getLevels: async () => await api.get('/admin/levels'),
    updateLevel: async (id, data) => await api.put(`/admin/levels/${id}`, data),
    deleteLevel: async (id) => await api.delete(`/admin/levels/${id}`),

    // Terms
    createTerm: async (data) => await api.post('/admin/terms', data),
    getTerms: async (params) => await api.get('/admin/terms', { params }),
    updateTerm: async (id, data) => await api.put(`/admin/terms/${id}`, data),
    deleteTerm: async (id) => await api.delete(`/admin/terms/${id}`),

    // Lessons
    createLesson: async (data) => await api.post('/admin/lessons', data),
    getLessons: async (params) => await api.get('/admin/lessons', { params }),
    updateLesson: async (id, data) => await api.put(`/admin/lessons/${id}`, data),
    deleteLesson: async (id) => await api.delete(`/admin/lessons/${id}`),

    // Experiments
    createExperiment: async (data) => await api.post('/admin/experiments', data),
    getExperiments: async (params) => await api.get('/admin/experiments', { params }),
    updateExperiment: async (id, data) => await api.put(`/admin/experiments/${id}`, data),
    deleteExperiment: async (id) => await api.delete(`/admin/experiments/${id}`),

    // Analytics
    getAnalytics: async () => await api.get('/admin/analytics'),
    getUsers: async (params) => await api.get('/admin/users', { params }),
    getRevenueStats: async (params) => await api.get('/admin/revenue', { params })
};